import {useLocation} from 'react-router-dom';
import {DrugItem} from 'store/types';

const useDrugDetails = () => {
  const {state} = useLocation();
  const {drug}: {drug: DrugItem} = state;

  return {drug};
};

export default useDrugDetails;
